jQuery(document).ready(function($){

    $('.read_more').each(function(){
        var $el = $(this);
        if ($el.height() > 80) {
            $el.after('<a href="#" class="read-more-toggle">Read more</a>');
        }
    });

    $(document).on('click', '.read-more-toggle', function(e){
        e.preventDefault();

        var $btn = $(this);
        var $content = $btn.prev('.read_more');

        if($content.hasClass('expanded')){
            // Collapse
            $content.removeClass('expanded');
            $btn.text('Read more');
        } else {
            // Expand
            $content.addClass('expanded');
            $btn.text('Read less');
        }
    });

});
